module.exports = __webpack_public_path__ + "static/media/valider.5583dfa8.svg";